import { CashRequestOptions, post } from '@cash-web/shared-util-fetch'
import { GetActiveIntegrationsRequest } from '@cash-web/shared-util-protos/squareup/franklin/app.pb'
import { GetActiveIntegrationsResponse } from '@cash-web/shared-util-protos/squareup/franklin/app.pb'

export const getActiveIntegrations = (request: GetActiveIntegrationsRequest, options?: CashRequestOptions) =>
  post<GetActiveIntegrationsRequest, GetActiveIntegrationsResponse>('/2.0/cash/get-active-integrations', request, {
    ...options,
    rejectOnError: true,
  })
